import { Injectable } from '@angular/core';

import { RegexControlValidator } from './regex-control-validator';
import { ControlValidatorType } from '../../types/validator.types';

@Injectable()
export class RegexControlInternalValidator extends RegexControlValidator {
  type = ControlValidatorType.RegularExpressionInternal;
}
